import React from "react";
import PrintTracking from "../PrintTracking/PrintTracking";
import {SUMMIT_ESCROW_TRACKING} from '../../consts/tables';
import Tracking from "../Tracking";
import { can } from "../../access";

export const tasks = [
    {
        id: 'NEGOTIATION_PRICE',
        name: 'Price',
        type: 'static',
        highlighted: false,
        canCollapse: false,
    },
    {
        id: 'NEGOTIATION_CAP_RATE',
        name: 'Cap Rate',
        type: 'static',
        highlighted: false,
        canCollapse: false,
    },
    {
        id: 'SELLER_NAME',
        name: 'Seller',
        type: 'static',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'BUYER_NAME',
        name: 'Buyer',
        type: 'static',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'BUYING_STATE',
        name: 'Buying State',
        type: 'static',
        highlighted: false,
        canCollapse: false,
    },
    // {
    //     id: 'PSA_SENT_TO_BUYER',
    //     name: 'PSA Sent to Buyer',
    //     type: 'date',
    //     highlighted: false,
    //     canCollapse: true,
    // },
    {
        id: 'PSA_SENT_TO_TITLE',
        name: 'PSA Sent to Title',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'HAVE_ALL_DUE_DILIGENCE_MATERIALS',
        name: 'Have all Due Diligence Materials?',
        type: 'dropdown',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'EFFECTIVE_DATE',
        name: 'Effective Date',
        type: 'date',
        highlighted: true,
        canCollapse: false,
        saveToProperty: true,
    },
    {
        id: 'ROFR_NOTICE_SENT_TO_TENANT',
        name: 'ROFR Notice Sent to Tenant',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'ROFR_WAIVER_SENT_TO_BUYERSIDE__TITLE_CO',
        name: 'ROFR Waiver Sent to Buyerside & Title Co',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    // {
    //     id: 'PSA_SENT_TO_TITLE',
    //     name: 'PSA Sent to Title',
    //     type: 'date',
    //     highlighted: false,
    //     canCollapse: true,
    // },
    {
        id: 'SURVEY_SENT_TO_TITLE',
        name: 'Survey Sent to Title',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'RECEIPTED_PSA_RECEIVED__SENT_TO_BUYERS_AGENT',
        name: 'Receipted PSA Received & Sent to Buyers Agent',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'DD_SITE_CREATED__ACCESS_GRANTED',
        name: 'DD Link',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'UPDATED_DB__ISUMMIT',
        name: 'Updated DB',
        type: 'dropdown',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'UPDATED_TO_UC_ON_EXTERNALS',
        name: 'Updated to UC on Externals',
        type: 'dropdown',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'WIRING_INSTRUCTIONS_SENT_TO_BUYERAGENT',
        name: 'Wiring Instructions Sent to Buyer/Agent',
        type: 'dropdown',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'EARNEST_MONEY_RECEIVED',
        name: 'Earnest Money Received',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'HAS_TITLE_APPROVED_SURVEY',
        name: 'Has Title Approved Survey?',
        type: 'dropdown',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'SURVEY_ORDERED',
        name: 'Survey Ordered, If Necessary',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'RECEIVED_TITLE_COMMITMENT',
        name: 'Received Title Commitment',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'BUYERS_TITLE_OBJECTIONS_DUE',
        name: 'Buyers Title Objections Due',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'SELLER_RESPONSE_TO_BUYER_OBJECTIONS',
        name: 'Seller Response to Buyer Objections',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'TITLE_OBJECTION_PERIOD',
        name: 'Title Objection Period Ends',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'FINANCING_APPLICATION_DEADLINE',
        name: 'Financing Application Deadline',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'FEASIBILITY_PERIOD',
        name: 'Feasibility Period (# of days)',
        type: 'text',
        highlighted: false,
        canCollapse: false,
    },
    {
        id: 'FEASIBILITY_EXTENSION',
        name: 'Feasibility Extension (# of Extra Days)',
        type: 'text',
        highlighted: false,
        canCollapse: false,
    },
    {
        id: 'FEASIBILITY_PERIOD_EXPIRES__DEPOSIT_NONREFUNDABLE',
        name: 'FEASIBILITY PERIOD EXPIRES - Deposit Non-Refundable',
        type: 'date',
        highlighted: true,
        canCollapse: false,
    },
    {
        id: 'FINANCING_APPROVAL',
        name: 'Financing Approval?',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'FINANCING_PERIOD_ENDS',
        name: 'Financing Period Ends',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'ADDITIONAL_EARNEST_MONEY_RECEIVED',
        name: 'Additional Earnest Money Received',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'ESTOPPELSNDA_REQUESTED_FROM_LENDER_BUYER_OR_TENANT',
        name: 'Estoppel/SNDA Requested from Lender, Buyer or Tenant',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'ESTOPPELSSDNA_DUE',
        name: 'Estoppels/SDNA Due',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'VERIFY_CLOSE_10_DAYS_BEFORE_CLOSING',
        name: 'Verify Close (~10 days before Closing)',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'SEND_TITLE_INVOICE_WIRE_CAM_DEPOSITS_PRORATIONS',
        name: 'Send Title (Invoice & Wire Instructions, Prorations, Deposits)',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'UPDATE_INSURANCE_CERTIFICATES',
        name: 'Update Insurance Certificates',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'TITLE_SENT_OUT_CLOSING_STATEMENTS_FOR_REVIEW',
        name: 'Title Sent Out Closing Statements for Review',
        type: 'date',
        highlighted: false,
        canCollapse: true,
    },
    {
        id: 'CLOSING_PERIOD',
        name: 'Closing Period (# of days)',
        type: 'text',
        highlighted: false,
        canCollapse: false,
    },
    {
        id: 'CLOSING_EXTENSION',
        name: 'Closing Extension (# of extra Days)',
        type: 'text',
        highlighted: false,
        canCollapse: false,
    },
    {
        id: 'CLOSING_DATE',
        name: 'CLOSING DATE',
        type: 'date',
        highlighted: true,
        canCollapse: false,
    },
    {
        id: 'ESCROW_OFFICER',
        name: 'Escrow Officer',
        type: 'vendorSelect',
        highlighted: false,
        canCollapse: false,
    },
    {
        id: 'TITLE_COMPANY',
        name: 'Title Company',
        type: 'titleCompanySelect',
        highlighted: false,
        canCollapse: false,
    },
    {
        id: 'BUYING_AGENT_NAME',
        name: 'Buying Agent',
        type: 'static',
        highlighted: false,
        canCollapse: false,
    },
    {
        id: 'FIRM_NAME',
        name: 'Buying Agent Firm',
        type: 'static',
        highlighted: false,
        canCollapse: false,
    },
    {
        id: 'LISTING_AGENT_NAME',
        name: 'Listing Agent ',
        type: 'static',
        highlighted: false,
        canCollapse: false,
    },
    {
        id: 'TRANSACTION_COORDINATOR_NAME',
        name: 'Transaction Coordinator',
        type: 'static',
        highlighted: false,
        canCollapse: false,
    }
];

const dateProps = tasks
    .filter(task => task.type === 'date')
    .map(task => task.id);

const checkboxProps = tasks
    .filter(task => task.type === 'date')
    .map(task => task.id + '_CHECKBOX');

const priceProps = ['NEGOTIATION_PRICE'];

const percentProps = ['NEGOTIATION_CAP_RATE'];

const excludedProps = ['AGENT_FIRST_NAME', 'AGENT_LAST_NAME', 'BUYER_FIRST_NAME', 'BUYER_LAST_NAME',
    'BUYER_COMPANY_NAME', 'BUYER_COMPANY_STATE', 'FIRM_NAME', 'TEAM_FIRST_NAME', 'TEAM_LAST_NAME', 'SELLER_FIRST_NAME',
    'SELLER_LAST_NAME', 'NEGOTIATION_PRICE', 'NEGOTIATION_CAP_RATE', 'BUYER_NAME', 'BUYING_AGENT_NAME', 'SELLER_NAME',
    'BUYING_STATE', 'BUYER_LEAD_ID', 'BUYER_INVESTOR_NAME', 'INVESTOR_NAME', 'LISTING_AGENT_NAME',
    'TRANSACTION_COORDINATOR_NAME', 'ESCROW_OFFICER_LEAD_ID'];

export default class EscrowTracking extends Tracking {
    constructor(props) {
        super(props);
    }

    /** Escrow Tracking: edit_all edits every deal, edit_own the deals they are an agent on, view nothing. */
    editsEveryRow() {
        return can('summit.escrow_tracking', 'edit_all');
    }

    editsOwnRows() {
        return can('summit.escrow_tracking', 'edit_own');
    }

    componentDidMount() {
        const propertyId = this.props.location.state || this.props.location.pathname.split('/')[2];
        this.fetch({propertyId, dateProps, checkboxProps, priceProps, percentProps, title: 'SUMMIT Escrow Tracking'});
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    render() {
        const {data, checkboxes, collapsed, areAllCollapsed} = this.state;
        const checkboxKeys = Object.keys(checkboxes);

        if (data === null) return null;
        if (data === false) return <div>No data found</div>;

        const d = new Date();
        const date = d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear();
        const isOneProperty = !!(this.props.location.state || this.props.location.pathname.split('/')[2]);

        return (
            <div className='Tracking'>
                <PrintTracking data={data} tasks={tasks} splitTaskId='FINANCING_APPLICATION_DEADLINE' title='SUMMIT Escrow Tracking'/>
                <div id="Tracking">
                    {this.renderHeader({date, tasks, dateProps, checkboxProps, priceProps, percentProps, excludedProps, tableCode: SUMMIT_ESCROW_TRACKING, areAllCollapsed})}
                    {this.renderTable({data, tasks, checkboxes, checkboxKeys, collapsed, isOneProperty})}
                </div>
            </div>
        );
    }
}